<script setup lang="ts">
import type { BreadcrumbItem } from '~/types/Breadcrumbs';

defineProps<{
  items: BreadcrumbItem[];
  theme?: 'light' | 'dark';
}>();
</script>

<template>
  <p class="breadcrumb small relative z-1 mb-10 flex flex-wrap gap-2">
    <span class="text-white/70 after:pl-2 after:content-['/']">
      <a href="/">Home</a>
    </span>
    <span
      v-for="crumb in items"
      class="shrink-0 text-white/70 capitalize after:pl-2 after:content-['/'] last-of-type:text-white/100 last-of-type:after:hidden last-of-type:after:pl-0"
    >
      <a :href="withTrailingSlash(crumb.href)">{{ crumb.label }}</a>
    </span>
  </p>
</template>
